module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (75).500289c8.jpg";